// extracted by mini-css-extract-plugin
export default {"nextPage":"nextPage__45aqp"};